import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials'
})
export class InitialsPipe implements PipeTransform {
  transform(fullName: string): string {
    if (!fullName) return '';

    const names = fullName.split(' ');
    let initials = '';
    
    // Iterate over names to get initials
    names.forEach(name => {
      if (name.length > 0) {
        initials += name.charAt(0).toUpperCase();
      }
    });

    return initials;
  }
}
